import Link from '../components/elements/link';
import SubTitle from '../components/elements/sub-title';
import Title from '../components/elements/title';
import UnorderedList from '../components/elements/unordered-list';
import { CONTACT_EMAIL } from '../constants';
import { FREE_SHIPPING_TRESHOLD } from '../constants';

export const TermsOfSaleNl = () => {
  return (
    <div>
      <Title>Verkoopsvoorwaarden</Title>
      <p className="my-2">Laatst aangepast op 2 juni 2021</p>
      <p className="my-2">
        Deze verkoopsvoorwaarden regelen het gebruik van de website van Gypsy Mode met ondernemingsnummer
        BE.0830.868.445 en maatschappelijke zetel te Jan Hijoensstraat 7, 8800 Roeselare (hierna 'de verkoper' genoemd).
      </p>
      <p className="my-2">
        De verkoopsvoorwaarden zijn van toepassing telkens wanneer een bestelling via de webshop van Gypsy de Saint
        Tropez wordt geplaatst.
      </p>
      <p className="my-2">
        De website werd gecreëerd in opdracht van en wordt beheerd door Gypsy Mode. Eenieder die een bestelling plaatst
        op de website (hierna genoemd 'de klant'), bevestigt door de bestelling een natuurlijk persoon en bovendien
        handelingsbekwaam te zijn.
      </p>
      <p className="my-2">
        Handelingsonbekwamen dienen zich te laten vertegenwoordigen door hun wettelijke vertegenwoordiger die eveneens
        gebonden is door deze verkoopsvoorwaarden en het bestelformulier zelf moet invullen dan wel de
        handelingsonbekwame hiertoe expliciete toestemming moet verlenen.
      </p>
      <p className="my-2">
        Het plaatsen van de bestelling houdt een betalingsverplichting in en geldt als uitdrukkelijke aanvaarding van
        deze algemene verkoopsvoorwaarden die zowel op de website worden gepubliceerd als bij de orderbevestiging worden
        meegestuurd. Voor het plaatsen van een bestelling is het aanvaarden van de algemene voorwaarden noodzakelijk.
        Wie besteld, verklaart de algemene voorwaarden van de verkoper te kennen en te aanvaarden. Wij leveren in Belgie
        en Nederland. De algemene voorwaarden zijn steeds beschikbaar en consulteerbaar via de website. Bij elke
        bestelling zijn de algemene voorwaarden van toepassing die op dat ogenblik op de website en orderbevestiging
        werden opgenomen, met uitsluiting van alle eventuele oudere of nieuwere bepalingen. Indien één van deze
        voorwaarden om welke reden dan ook niet rechtsgeldig zou zijn, blijven de overige voorwaarden onverkort van
        toepassing.
      </p>
      <p className="my-2">
        Wat niet uitdrukkelijk is bepaald indeze verkoopsvoorwaarden, wordt geregeld door de bepalingen van het
        Belgische recht. De voertaal van de afgesloten overeenkomsten is Nederlands. Er kan steeds contact worden
        opgenomen met de klantendienst ingeval van onduidelijkheid.
      </p>
      <SubTitle>Aanbod en bestelling</SubTitle>
      <UnorderedList>
        <p className="my-2">
          We beschrijven zo volledig en nauwkeurig mogelijk wat we je verkopen. De afbeeldingen, zijn een
          waarheidsgetrouwe weergave van de aangeboden goederen.
        </p>
        <p className="my-2">
          De bestelling is compleet en de overeenkomst tussen ons is definitief zodra we je bestelling bevestigen per
          mail en zodra we voor je betalingstransactie de goedkeuring door de uitgever van de kaart ontvangen hebben. We
          aanvaarden Visa, MasterCard, Apple Pay, bancontact en IDeal. Als de uitgever van je kaart weigert om in te
          stemmen met je betaling, kunnen wij niet verantwoordelijk worden gesteld voor vertragingen bij de levering
          en/of niet-levering van uw bestelling. Bestellingen zonder geldige betaling op naam van de geregistreerde
          kaarthouder worden niet aanvaard of verwerkt.
        </p>
        <p className="my-2">
          Om een product aan te kopen, voeg je het product toe aan je winkelmandje. Nadien geef je je contactgegevens en
          facturatiegegevens in. Vervolgens kies je je wijze van levering: bezorging op je gekozen adres of afhalen in
          de winkel. In de laatste stap krijg je een overzichtspagina, aanvaard je onze algemene voorwaarden en bevestig
          je je betaling door het indrukken van de bestelknop. Als je deze stappen hebt doorlopen, is je aankoop
          definitief.
        </p>
        <p className="my-2">
          De leveringstermijn gaat pas in na ontvangst van betaling. Er wordt gestreefd naar een zo kort mogelijke
          leveringstermijn. De leveringstermijn bedraagt minimaal 1 werkdag en maximaal 30 dagen na ontvangst van de
          betaling voor levering. De verkoper is niet aansprakelijk voor vertraging of uitblijven van de levering door
          toedoen van de vervoerder.
        </p>
        <p className="my-2">
          Onze prijzen zijn inclusief alle belastingen, BTW, taksen. Verzendingskosten zijn niet inbegrepen.
        </p>
        <p className="my-2">Leveringen naar een afhaalpunt zijn gratis vanaf {FREE_SHIPPING_TRESHOLD} euro.</p>
      </UnorderedList>
      <SubTitle>Betaling</SubTitle>
      <UnorderedList>
        <p className="my-2">
          Wij kunnen bij bestellingen enkel betaling via de betaalmodus op onze website aanvaarden.
        </p>
        <p className="my-2">
          Om een veilige online betaling en de veiligheid van je persoonsgegevens te waarborgen, maken wij gebruik van
          Mollie, voor meer informatie{' '}
          <Link href="https://www.mollie.com/en/features/security" isExternal>
            klik hier
          </Link>
          .
        </p>
      </UnorderedList>
      <SubTitle>Levering</SubTitle>
      <UnorderedList>
        <p className="my-2">
          We zullen de grootst mogelijke zorgvuldigheid in acht nemen bij het uitvoeren van bestellingen.
        </p>
        <p className="my-2">
          Geplaatste bestellingen zullen verzonden worden met de door U gekozen dienst binnen de 24u. In drukkere
          periodes, zoals solden of nieuwe collectie, kan vertraging optreden. Als u besteld in het weekend, of op een
          feestdag, zal de bestelling de eerstvolgende werkdag behandelt worden.
        </p>
        <p className="my-2">
          Onze verzendingen gebeuren tot het moment van bezorging aan jou of een door jou aangewezen vertegenwoordiger
          op ons risico. Als je ons goederen terugzendt binnen de 14 dagen na aankoop, ben jij verantwoordelijk voor het
          transport.
        </p>
        <p className="my-2">
          Indien de door ons geleverde goederen tijdens het transport werden beschadigd, of niet overeenkomen met de
          items die je had besteld, moet je dit zo snel mogelijk melden en de artikelen naar ons terugsturen binnen de
          14 kalenderdagen na aankoop.
        </p>
        <p className="my-2">
          We kunnen niet verantwoordelijk worden gesteld voor enige schade wegens laattijdige levering of niet-levering
          door de transporteur. Onze aansprakelijkheid blijft in dergelijke gevallen beperkt tot de waarde van de
          artikelen waarvan wordt aangetoond dat ze niet door de klant werden ontvangen
        </p>
      </UnorderedList>
      <SubTitle>Retour</SubTitle>
      <UnorderedList>
        <p className="my-2">
          Als je goederen koopt, heb je gedurende 14 dagen vanaf de levering het recht om te beslissen dat je de
          goederen al dan niet wil houden (poststempel geld als bewijs). Gelieve ons hiervoor eerst te contacteren op
          {CONTACT_EMAIL} met vermelding van uw ordernummer, datum en naam. Nadat wij je de retour hebben bevestigd, kan
          je je bestelling retourneren. Binnen de 14 dagen nadat we je bestelling teruggekregen hebben betalen we je de
          volledige aankoopprijs exclusief verzendkosten terug.
        </p>
        <p className="my-2">Wij wachten met terugbetaling tot wij de goederen hebben teruggekregen.</p>
        <p className="my-2">
          Je kan je items retourneren tot 14 dagen na levering, op eigen kosten, met een door jezelf uitgekozen
          koerierdienst. Elke retour is ten laste van de koper. Wij raden je aan met traceerbare zending te werken, en
          je bewijs bij te houden. Wij zijn niet verantwoordelijk voor verloren gegane pakketjes bij een retourzending.
        </p>
        <p className="my-2">
          In ieder geval wordt retour enkel aanvaard indien het artikel gelabeld, onbevuild, onbeschadigd en ongedragen
          is en zich in de originele verpakking bevindt.
        </p>
        <p className="my-2">
          Artikels gekocht tijdens de soldenperiode, soldenartikels, uitzonderlijke verkopen (zoals sales, uitverkoop,
          black friday, batjes, braderie, outlet en speciale aanbiedingen) alsook items voorzien van een promo actie,
          worden niet geruild of geretourneerd.
        </p>
        <p className="my-2">
          Bij het niet navolgen van deze richtlijnen, wordt het geretourneerde product beschouwd als niet conform onze
          retourpolicy en wordt het niet geruild of geretourneerd.
        </p>
      </UnorderedList>
      <SubTitle>Intellectuele eigendom</SubTitle>
      <p className="my-2">
        Onze website, logo's, teksten, foto's, namen en in het algemeen al onze communicatie zijn beschermd door
        intellectuele eigendomsrechten die hetzij bij ons, hetzij bij onze toeleveranciers of andere rechthebbenden
        liggen.
      </p>
      <p className="my-2">
        Het is verboden gebruik te maken van en/of wijzigingen aan te brengen in de intellectuele eigendomsrechten zoals
        beschreven in dit artikel. Zo mag je bijvoorbeeld tekeningen, foto's namen, teksten, logo's kleurencombinatie,
        etc ... niet kopiëren of reproduceren zonder onze voorafgaande en uitdrukkelijke schriftelijke toestemming.
      </p>
      <SubTitle>Bescherming van de privacy</SubTitle>
      <p className="my-2">
        Door het plaatsen van een bestelling, verklaart de klant kennis te hebben genomen van het Privacybeleid van de
        verkoper. Het Privacybeleid van de verkoper bevat de nodige informatie over hoe en waarvoor persoonsgegevens
        worden verwerkt en welke cookies worden gebruikt.
      </p>
      <p className="my-2">
        Voor het uitoefenen van het recht inzake inzage, wijziging of schrapping van persoonsgegevens, kan de klant
        contact opnemen met de klantendienst, volgens de procedure beschreven in het Privacybeleid van de verkoper. De
        klant kan zelf zijn gegevens wijzigen via zijn accountprofiel.
      </p>
      <SubTitle>Bevoegdheid en toepasselijk recht</SubTitle>
      <p className="my-2">
        Deze overeenkomst is onderworpen aan de bepalingen van het Belgische recht. Ingeval van betwisting zijn enkel de
        zetels van het arrondissement Kortrijk, België bevoegd.
      </p>
    </div>
  );
};
